<script>
  import Button from '$lib/components/Button.svelte';
  import Modal from '$lib/components/Modal.svelte';
  import { closeModal, showToast } from '$lib/features/app/modals';
  import { useQueryClient } from '@tanstack/svelte-query';
  import { useSetConsultationHistoryToSignedMutation } from '../../service';
  import { user } from '$lib/features/auth/authStore';
  import { logger } from '$lib/logger';

  let { note } = $props();

  const queryClient = useQueryClient();
  const signConsultationMutation = useSetConsultationHistoryToSignedMutation();

  function handleSubmit() {
    $signConsultationMutation.mutate(
      {
        noteId: note.id,
        user: $user.id,
      },
      {
        onSuccess: () => {
          showToast('Journalen är signerad', 'success');
          queryClient.invalidateQueries({ queryKey: ['notes'] });
          closeModal();
        },
        onError: (e) => {
          showToast(e.message, 'error');
          logger.error('Failed to sign saved note', {
            err: e instanceof Error ? e : undefined,
          });
        },
      },
    );
  }
</script>

<Modal title="Signera journalanteckningen" size="sm">
  <form
    onsubmit={(event) => {
      event.preventDefault();
      handleSubmit();
    }}
    class="w-full"
  >
    <div class="mt-4 flex justify-between">
      <Button onclick={closeModal} variant="secondary" iconLeft="cancel">
        Avbryt
      </Button>
      <Button
        type="submit"
        variant="primary"
        class="w-40"
        loading={$signConsultationMutation.isPending}
      >
        Signera
      </Button>
    </div>
  </form>
</Modal>
